<template>
	<div class="c-expand">
		<div class="c-expand__fold">
			<button
				:id="id"
				:aria-expanded="isExpanded ? true : false"
				:aria-controls="isExpanded ? contentId : null"
				class="c-expand__label"
				type="button"
				@click="toggleExpand">
				<span class="c-expand__icon" :class="{ 'c-expand__rotate': isExpanded }">
					<v-icon v-if="isExpanded" name="icon-open-circle"></v-icon>
					<v-icon v-else name="icon-open-circle"></v-icon>
					<span class="t-visually-hidden">{{isExpanded ? 'Stäng' : 'Öppna'}}</span>
				</span>
				<span class="c-expand__title">
					<slot name="title"></slot>
				</span>
			</button>
			<div
				:id="contentId"
				class="c-expand__content"
				v-if="isExpanded"
				:aria-hidden="!isExpanded ? true : false"
				:aria-labelledby="id">
				<div class="c-expand__content-inner">
					<slot name="content"></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import VIcon from '../../components/icon/VIcon.vue';

export default {
	name: 'VExpand',
	components: {
		VIcon
	},
	props: {
		id: {
			type: String,
			default: ''
		},
		contentId: {
			type: String,
			default: ''
		}
	},
	data () {
		return {
			isExpanded: false
		}
	},
	methods: {
		toggleExpand() {
			this.isExpanded = !this.isExpanded;
		}
	}
}
</script>
